<template>
  <section class="light-gallery-section">
    <b-container>
      <b-row>
        <b-col sm="12" md="12" lg="12">
          <div class="gallery-container">
          <div class="gallery-photos-box">
            <div class=image-show v-for="(photo, index) in photos" :key="index">
              <img :src="photo.url" :alt="photo.alt" />
            </div>
          </div>
            <div class="gallery-msg-box">
              {{$t('text_gallery')}}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {
      photos: [
        { url: require('@/assets/img/gallery/reward.png'), alt: 'Reward image' },
        { url: require('@/assets/img/gallery/stand.jpg'), alt: 'Agatis games image' },
        { url: require('@/assets/img/gallery/gameplay.jpg'), alt: 'Gameplay image' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/app.scss";

  .light-gallery-section{
    padding-top: 40px;
    padding-bottom: 80px;
    background: #20201E;
    gap: 24px;
    .gallery-container{
      display: flex;
      flex-direction: column;
      gap: 24px;
      @media screen and (min-width: 320px) {
           flex-direction: column-reverse;
        }
        @media screen and (min-width: 768px) {
           flex-direction: column;
        }
      .gallery-photos-box {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 24px;
        @media screen and (min-width: 320px) {
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        @media screen and (min-width: 768px) {
          flex-direction: row;
          justify-content: center;
          align-items: flex-start;
        }
        .image-show{
        @media screen and (min-width: 320px) {
          width: 100%;
        }
        @media screen and (min-width: 768px) {
          width: auto;
        }
          img{
            width: 100%;
            height: auto;
          }
        }
      }
      .gallery-msg-box {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 702px;
        width: 100%;
        margin: 0 auto;
        text-align: center;
        color: #96D6DF;
        font-family: $main-font;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        @media screen and (min-width: 320px) {
          font-size: 16px;
          font-weight: 600;
          line-height: 22.4px;
        }
        @media screen and (min-width: 768px) {
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          line-height: 28px;
        }
      }
    }
  }
</style>
